<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title mb-4">Inventory Mails Notifications</div>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-12 col-md-3 mb-2">
          <div class="dropdown-curve-container">
            <label :class="cinema_id ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="Cinemas"
              v-model="selectedCinema"
              :searchable="true"
              placeholder=""
              label="cine_name"
              track-by="cine_id"
              @select="onSelectCinema($event)"
              :allowEmpty="false"
            >
            </multiselect>
          </div>
        </div>
      </div>

      <div class="row" v-if="cinema_id">
        <div
          class="col-6 mb-4"
          v-for="(settings, settingIndex) in mail_settings"
          :key="settingIndex"
        >
          <div class="swc-report mt-3">
            <div>
              <span class="settingName">
                {{ settings["setting_name"] }}
              </span>
            </div>
            <table class="swc-report-table border w-100" border="1">
              <tbody>
                <tr>
                  <th class="text-left">To Mail</th>
                  <td class="text-center">
                    <input
                      class="email_fields"
                      :class="{ 'is-invalid': validationErrors[`email_to_${settingIndex}`] }"
                      :name="`${'email_to' + settings['setting_name']}`"
                      :id="`${'email_to' + settings['setting_name']}`"
                      type="email"
                      v-model="settings.email_to"
                      @blur="validateSingleEmail('email_to', settingIndex, settings.email_to)"
                    />
                    <div v-if="validationErrors[`email_to_${settingIndex}`]" class="invalid-feedback">
                      {{ validationErrors[`email_to_${settingIndex}`] }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    CC Mail
                    <span class="setting-sm-description">*Comma Seperated</span>
                  </th>
                  <td class="text-center">
                    <input
                      class="email_fields"
                      :class="{ 'is-invalid': validationErrors[`email_cc_${settingIndex}`] }"
                      :name="`${'email_cc' + settings['setting_name']}`"
                      :id="`${'email_cc' + settings['setting_name']}`"
                      type="email"
                      v-model="settings.email_cc"
                      @blur="validateMultipleEmails('email_cc', settingIndex, settings.email_cc)"
                    />
                    <div v-if="validationErrors[`email_cc_${settingIndex}`]" class="invalid-feedback">
                      {{ validationErrors[`email_cc_${settingIndex}`] }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="text-left">
                    BCC Mail
                    <span class="setting-sm-description">*Comma Seperated</span>
                  </th>
                  <td class="text-center">
                    <input
                      class="email_fields"
                      :class="{ 'is-invalid': validationErrors[`email_bcc_${settingIndex}`] }"
                      :name="`${'email_bcc' + settings['setting_name']}`"
                      :id="`${'email_bcc' + settings['setting_name']}`"
                      type="email"
                      v-model="settings.email_bcc"
                      @blur="validateMultipleEmails('email_bcc', settingIndex, settings.email_bcc)"
                    />
                    <div v-if="validationErrors[`email_bcc_${settingIndex}`]" class="invalid-feedback">
                      {{ validationErrors[`email_bcc_${settingIndex}`] }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
        class="w-100 d-flex justify-content-center align-items-center mt-3"
        v-if="cinema_id"
      >
        <div class="btn btn-sm btn-primary mr-2" @click="updateMailSettings()">
          Save
        </div>
        <div
          class="btn btn-sm btn-outline-primary"
          @click="cancelMailSetting()"
        >
          Cancel
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import _ from "lodash";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      cinema_id: null,
      isRoleID: true,
      Cinemas: [],
      selectedCinema: "",
      validationErrors: {}, // Store validation errors
      mail_settings: [
        {
          imn_id: null,
          setting_name: "Minimum Stock Mails",
          setting_type_id: 1,
          cinema_id: null,
          email_to: "",
          email_cc: "",
          email_bcc: "",
          mobile_nos: "",
          inm_is_active: "Y",
        },
        {
          imn_id: null,
          setting_name: "Transfer Stock Mails",
          setting_type_id: 2,
          cinema_id: null,
          email_to: "",
          email_cc: "",
          email_bcc: "",
          mobile_nos: "",
          inm_is_active: "Y",
        },
      ],
    };
  },
  computed: {},
  beforeMount() {
    if (!this.$can("read", "Inventory Notification Settings")) {
      this.$router.go(-1);
    }

    let obj = this.secureStore.get("USINFO").cinema_id;
    if (obj) {
      this.getCinemas(obj);
    } else {
      this.getCinemas();
    }
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.getCinemas(CinemaObj.cine_id);
      this.selectedCinema = CinemaObj;
      this.cinema_id = CinemaObj.cine_id;
    }
  },
  methods: {
    // Email validation regex
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email.trim());
    },

    // Validate single email (for "To" field)
    validateSingleEmail(fieldType, index, value) {
      const key = `${fieldType}_${index}`;
      
      // Clear previous error
      this.$delete(this.validationErrors, key);
      
      if (value && value.trim()) {
        if (!this.isValidEmail(value)) {
          this.$set(this.validationErrors, key, 'Please enter a valid email address');
        }
      }
    },

    // Validate multiple emails (for CC and BCC fields)
    validateMultipleEmails(fieldType, index, value) {
      const key = `${fieldType}_${index}`;
      
      // Clear previous error
      this.$delete(this.validationErrors, key);
      
      if (value && value.trim()) {
        const emails = value.split(',').map(email => email.trim()).filter(email => email);
        const invalidEmails = emails.filter(email => !this.isValidEmail(email));
        
        if (invalidEmails.length > 0) {
          this.$set(this.validationErrors, key, `Invalid email(s): ${invalidEmails.join(', ')}`);
        }
      }
    },

    // Validate all emails before saving
    validateAllEmails() {
      this.validationErrors = {}; // Clear all errors
      let hasErrors = false;

      this.mail_settings.forEach((settings, index) => {
        // Validate To email
        if (settings.email_to && settings.email_to.trim()) {
          if (!this.isValidEmail(settings.email_to)) {
            this.$set(this.validationErrors, `email_to_${index}`, 'Please enter a valid email address');
            hasErrors = true;
          }
        }

        // Validate CC emails
        if (settings.email_cc && settings.email_cc.trim()) {
          const ccEmails = settings.email_cc.split(',').map(email => email.trim()).filter(email => email);
          const invalidCcEmails = ccEmails.filter(email => !this.isValidEmail(email));
          
          if (invalidCcEmails.length > 0) {
            this.$set(this.validationErrors, `email_cc_${index}`, `Invalid email(s): ${invalidCcEmails.join(', ')}`);
            hasErrors = true;
          }
        }

        // Validate BCC emails
        if (settings.email_bcc && settings.email_bcc.trim()) {
          const bccEmails = settings.email_bcc.split(',').map(email => email.trim()).filter(email => email);
          const invalidBccEmails = bccEmails.filter(email => !this.isValidEmail(email));
          
          if (invalidBccEmails.length > 0) {
            this.$set(this.validationErrors, `email_bcc_${index}`, `Invalid email(s): ${invalidBccEmails.join(', ')}`);
            hasErrors = true;
          }
        }
      });

      return !hasErrors;
    },

    getCinemas: function (cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(x);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onSelectCinema: function (params) {
      this.selectedCinema = params;
      this.cinema_id = params.cine_id;
      this.$store.dispatch("selectDropdownCinema", params);
      this.getMailSettings();
    },
    getMailSettings() {
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.cinema_id,
      };
      MasterService.GetInventoryMailSettings(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.mail_settings = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    cancelMailSetting() {
      this.$router.push({
        path: "/",
      });
    },
    updateMailSettings() {
      if (!this.cinema_id) {
        this.$toasted.show("Please Select Cinema");
        return;
      }

      // Validate all emails before saving
      if (!this.validateAllEmails()) {
        this.$toasted.show("Please fix the email validation errors before saving");
        return;
      }

      let loader = this.$loading.show();
      let payload = {
        inventory_settings: this.mail_settings,
        cinema_id: this.cinema_id,
      };
      MasterService.UpdateInventoryMailSettings(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$router.push({
              path: "/",
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
};
</script>

<style>
.stockUOM-dropdowm .multiselect__content-wrapper {
  width: 160px !important;
}

.reason_multiselect .multiselect__content-wrapper {
  width: 200px !important;
}

.table-wrapper .list-view-table {
  /* width: auto!important; */
  table-layout: auto;
  /* white-space: nowrap; */
}

.table-wrapper .list-view-table th {
  padding: 5px 10px 5px 10px;
}

.bg-red {
  color: red;
  background-color: transparent !important;
}

.bg-green {
  color: green;
}

.bg-transparent {
  background-color: transparent !important;
  color: black !important;
}

.email_fields {
  width: 100%;
  border: none;
}

.settingName {
  font-size: 14px;
  color: #646363;
  white-space: nowrap;
  font-weight: 600;
}

.setting-sm-description {
  font-size: 10px;
  color: grey;
  font-style: italic;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/InventoryManagements/InventoryMails.vue